import axios from 'axios';
import { HttpComm } from './HttpComm';
import { API_URL } from '../../config';

// 브라우저 환경에서는 process.env가 없으므로, 일단 고정 URL을 사용합니다.
// 나중에 필요하면 webpack DefinePlugin 등으로 환경변수 주입 방식으로 변경할 수 있습니다.
//const API_URL = 'http://localhost:8080';

const instance = axios.create({
  baseURL: API_URL,
  timeout: 60000,
});

export const ApiComm = new HttpComm(instance);
